module.exports = __webpack_public_path__ + "media/PunkAngels_reveal_square.76f9c0ed.mp4";